import type { ButtonRect } from "../ui/layout";
import { CANVAS_FONT_FAMILY } from "./fonts";
export function pill(
  c: CanvasRenderingContext2D,
  r: ButtonRect,
  top = "#FFFFFF",
  bottom = "#ECEBFF",
  radius = 20,
): void {
  c.fillStyle = "#2A2440";
  c.beginPath();
  c.roundRect(r.x, r.y + 5, r.width, r.height, radius);
  c.fill();
  const gradient = c.createLinearGradient(0, r.y, 0, r.y + r.height);
  gradient.addColorStop(0, top);
  gradient.addColorStop(1, bottom);
  c.fillStyle = gradient;
  c.beginPath();
  c.roundRect(r.x, r.y, r.width, r.height, radius);
  c.fill();
  c.strokeStyle = "#2A2440";
  c.lineWidth = 3;
  c.stroke();
}
export function outlinedText(
  c: CanvasRenderingContext2D,
  text: string,
  x: number,
  y: number,
  size: number,
  fill = "#FFFFFF",
  stroke = "#2A2440",
  line = 3,
): void {
  c.font = `700 ${size}px ${CANVAS_FONT_FAMILY}`;
  c.textAlign = "center";
  c.textBaseline = "middle";
  c.strokeStyle = stroke;
  c.lineWidth = line;
  c.lineJoin = "round";
  if (line > 0) c.strokeText(text, x, y);
  c.fillStyle = fill;
  c.fillText(text, x, y);
}
export function star(
  c: CanvasRenderingContext2D,
  x: number,
  y: number,
  r: number,
  color = "#FFD640",
): void {
  c.beginPath();
  for (let i = 0; i < 10; i++) {
    const a = (i * Math.PI) / 5 - Math.PI / 2,
      rr = i % 2 ? r * 0.42 : r;
    const xx = x + Math.cos(a) * rr,
      yy = y + Math.sin(a) * rr;
    if (i) c.lineTo(xx, yy);
    else c.moveTo(xx, yy);
  }
  c.closePath();
  c.fillStyle = color;
  c.fill();
}
export function avatar(
  c: CanvasRenderingContext2D,
  r: ButtonRect,
  team: string,
  flash = false,
  squash = 0,
): void {
  c.save();
  c.translate(r.x + 28, r.y + 28);
  c.scale(1 + 0.15 * squash, 1 - 0.12 * squash);
  c.beginPath();
  c.arc(0, 0, 28, 0, Math.PI * 2);
  c.fillStyle = team;
  c.fill();
  c.strokeStyle = "#2A2440";
  c.lineWidth = 2.5;
  c.stroke();
  c.clip();
  const bg = c.createLinearGradient(0, -28, 0, 28);
  bg.addColorStop(0, team);
  bg.addColorStop(1, "#EEE9FF");
  c.fillStyle = bg;
  c.fillRect(-28, -28, 56, 56);
  c.fillStyle = flash ? "#FFB4AD" : "#FFFFFF";
  c.beginPath();
  c.ellipse(0, 10, 19, 19, 0, 0, Math.PI * 2);
  c.fill();
  c.fillStyle = team;
  c.beginPath();
  c.ellipse(0, -6, 20, 19, 0, Math.PI, Math.PI * 2);
  c.fill();
  c.fillRect(-20, -8, 40, 8);
  c.beginPath();
  c.roundRect(-22, -5, 44, 10, 4);
  c.fill();
  c.beginPath();
  c.arc(0, -24, 6, 0, Math.PI * 2);
  c.fill();
  c.strokeStyle = "#2A2440";
  c.lineWidth = 2;
  c.beginPath();
  c.arc(-7, 11, 2, 0, Math.PI * 2);
  c.arc(7, 11, 2, 0, Math.PI * 2);
  c.stroke();
  c.beginPath();
  c.arc(0, 17, 4, 0, Math.PI);
  c.stroke();
  c.fillStyle = "#FFB1C9";
  c.beginPath();
  c.ellipse(-12, 17, 3, 2, 0, 0, Math.PI * 2);
  c.ellipse(12, 17, 3, 2, 0, 0, Math.PI * 2);
  c.fill();
  c.restore();
}
